import React from 'react'

import { Wrapper } from './FormSection.styles'

/**
 *
 */

// @ts-expect-error TS(7031) FIXME: Binding element 'children' implicitly has an 'any'... Remove this comment to see the full error message
const FormSection = ({ children, withBg }) => (
  // @ts-expect-error TS(2769) FIXME: No overload matches this call.
  <Wrapper withBg={withBg}>{children}</Wrapper>
)

export default FormSection
